import axios from '../../../services/axios.service';
import { getEndpointBase } from '../../../services/api.service';
import { ControlPanelListResponse } from './ControlPanelList.type';
import { AxiosResponse } from 'axios';

let listRequest: any = null;

export const controlPanelListService = {
  getList: (): Promise<AxiosResponse<ControlPanelListResponse>> => {
    listRequest && listRequest.cancel();
    listRequest = axios.CancelToken.source();

    return axios.get(getEndpointBase('panel/list'), {
      cancelToken: listRequest.token,
    });
  },
};
